// extracted by mini-css-extract-plugin
module.exports = {"page":"trade_page__V84Bm","pageWrapper":"trade_pageWrapper__9LerY","contentWrapper":"trade_contentWrapper__VaEuN"};